import { createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import type { CancelTokenSource } from "axios";
import FS from "indexeddb-fs";
import { RootState } from "store";
import type { Track } from "store/track/track.model";
import { archiveActions } from "./archive.slice";

const cancelTokenSources: { [trackId in string]: CancelTokenSource } = {};

export const archiveTrack = createAsyncThunk(
  "archive/archiveTrack",
  async ({ track }: { track: Track }, { dispatch, getState }) => {
    if (!track.streamLink) return;
    const state: RootState = getState() as RootState;
    const archivedTracks = state.persistedReducer.archive.tracks;
    const archivedTrack = archivedTracks.find((t) => t.id === track.id);
    if (archivedTrack) return;
    const onDownloadProgress = (event: ProgressEvent) => {
      const downloadProgress = event.loaded / event.total;
      dispatch(
        archiveActions.setTrackDownloadProgress({
          trackId: track.id,
          downloadProgress,
        })
      );
    };
    const cancelToken = Axios.CancelToken;
    const cancelTokenSource = cancelToken.source();
    cancelTokenSources[track.id] = cancelTokenSource;
    dispatch(archiveActions.addTrack({ track }));
    const request = Axios.get(track.streamLink, {
      onDownloadProgress,
      cancelToken: cancelTokenSource.token,
      responseType: "blob",
      timeout: 3600000,
    });
    request.then(async (response) => {
      let data: any = await response.data;
      FS.writeFile(`root/${track.id}`, data).then((fileEntry) => {});
    });
    request.catch((reason) => {
      console.log("Download Error!", reason);
      dispatch(archiveActions.removeTrack({ trackId: track.id }));
    });
  }
);

export const removeArchivedTrack = createAsyncThunk(
  "archive/removeArchivedTrack",
  async ({ trackId }: { trackId: Track["id"] }, { dispatch, getState }) => {
    const state: RootState = getState() as RootState;
    const tracks = state.persistedReducer.archive.tracks;
    const track = tracks.find((t) => t.id === trackId);
    if (track) {
      if (cancelTokenSources[trackId]) {
        try {
          cancelTokenSources[trackId].cancel("");
        } catch (e) {}
      }
      dispatch(archiveActions.removeTrack({ trackId }));
      try {
        FS.removeFile(`root/${trackId}`);
      } catch (e) {}
    }
  }
);
